export enum VariableSchemaEntityType {
  ENTITY = 'ENTITY',
  ENVIRONMENT = 'ENVIRONMENT',
}
